function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.0318 0 0 .88809 -1.6904 -.27223)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.2307 0 0 .2307 -18.279 -27.316)",
  fill: "none",
  stroke: "#000"
}, /*#__PURE__*/React.createElement("path", {
  d: "m120.7 192.82-2.1754 3.1753h6.4449l-2.3492-3.1753z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m113.54 170.46 0.9649 16.242"
}), /*#__PURE__*/React.createElement("path", {
  d: "m113.54 170.46 0.9649 16.242"
}), /*#__PURE__*/React.createElement("path", {
  d: "m130.1 170.38-0.9649 16.242"
}), /*#__PURE__*/React.createElement("path", {
  d: "m120.48 170.57h2.1337v22.244h-1.9204z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121.52,
  cy: 146.01,
  r: 7.3954
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121.58,
  cy: 146.06,
  r: 6.043
}), /*#__PURE__*/React.createElement("path", {
  d: "m113.82 136.38h15.469"
}), /*#__PURE__*/React.createElement("path", {
  d: "m116.01 193.27-0.80542 1.3951h3.7005l-0.84072-1.4561z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m125.76 193.03-0.82717 1.7922h3.5154l-1.0753-1.8625z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m121.55 121.17-2.6959 1.7627-2.1775 4.4587-1.2443 3.007-1.2443 4.1476-0.82953 4.0439-0.62214 3.8365-0.41476 3.6292 0.16817 4.8612 0.16089 2.3318 0.24122 3.7792v0.96488l0.32164 5.0657 0.32162 7.3975-8.4428 6.513 1.769 22.112h1.5277l0.56286-9.4077 0.64325-0.96489 1.2865-0.88447 1.3669-0.88448 1.2061-0.16089 1.0453-0.0804 0.32162 6.2718h6.0306v6.2718h1.9298v-6.1914h6.3522v-6.1914h1.2061l2.4122 0.9649 1.769 0.72366 0.32163 1.1257 0.16089 0.96491v8.3624h2.3318l1.2865-22.836-8.5232-5.7892 1.0453-25.489-2.4926-11.9-2.573-7.2367-2.2514-3.3771z"
})));

var SvgProjects = function SvgProjects(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProjects, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/projects.15989aa5.svg";
export { ForwardRef as ReactComponent };